import React from "react";

function Url(props) {
    return (
        <a
            key={props.key}
            href={props.value}
            target="_blank"
            rel="noopener noreferrer"
            className="url"
        >
            {props.label}
        </a>
    );
}

export default Url;